<template>
  <div class="has-background-white is-border">
    <lot-form
      @submit="createLot"
      :source-loading="loading"
      :source-lot-program="lotProgram"></lot-form>
  </div>
</template>

<script>
import LotMixin from './LotMixin'

export default {
  name: 'LotCreate',
  components: {
    LotForm: () => import('@/components/lots/LotForm')
  },
  mixins: [LotMixin],
  watch: {
    sourceLotProgram (v) {
      if (v) this.updateSources({ program: v })
    }
  }
}
</script>
